import React from 'react'
import Link from 'gatsby-link'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import { Segment, Breadcrumb, Icon } from 'semantic-ui-react'
import Helmet from 'react-helmet'

const AboutPage = () => (
  <div style={{ maxWidth: 1260, margin: '0 auto' }}>
   <Helmet>
      <title>About | Find Growth Tools</title>
      <meta name="description" content="A curated list of the best SaaS growth tools." />

    </Helmet>
    <Segment basic>
      <Breadcrumb>
        <Breadcrumb.Section link>
          <Link to="/" 	style={{color: '#dcddde'}}>
            <Icon name="angle left" />Home
          </Link>
        </Breadcrumb.Section>
     
        {/* <Breadcrumb.Section active>About</Breadcrumb.Section> */}
      </Breadcrumb>
    </Segment>
    <h1
      style={{
        fontSize: '3.25rem',
        color: '#fff'
      }}
    >
      About
    </h1>
    <br />
    <div style={{ maxWidth: 960, margin: '0 auto' }}>
    <Segment style={{padding:'40px'}}>
      <h2 style={{  textAlign: 'center' }}>
        A curated list of the best SaaS software to help companies grow.
      </h2>
      <br/>
      <p style={{ fontSize: '1.25em', textAlign: 'center' }}>
        FindGrowthTools is made by <OutboundLink href="https://twitter.com/_davidturnbull" target="_blank">
          David Turnbull
        </OutboundLink>, a growth marketer based in Stockholm, Sweden. 
        <br/> <br/>
        Rather than listing every product within a category, Find Growth Tools aims to provide a selection of the best tools used or recommended by David and his friends and collegaues. 
      <br/><br/>

      <em>Know a great growth tool that's missing from the site? <Link to="/suggest" >Make a suggestion!</Link></em>

      <h4>Tech Stack</h4>
      
        The site has been built using <OutboundLink href="https://www.gatsbyjs.org/" target="_blank">GatsbyJS
        </OutboundLink>, <OutboundLink href="https://www.netlify.com/" target="_blank">Netlify
        </OutboundLink> and <OutboundLink href="https://www.contentful.com/" target="_blank">Contentful
        </OutboundLink>. 
        </p>
      </Segment>
      <br/>
    </div>
  </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/about.js